import { render, staticRenderFns } from "./StackAlert.vue?vue&type=template&id=0e336838&scoped=true"
import script from "./StackAlert.vue?vue&type=script&lang=js"
export * from "./StackAlert.vue?vue&type=script&lang=js"
import style0 from "./StackAlert.vue?vue&type=style&index=0&id=0e336838&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e336838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e336838')) {
      api.createRecord('0e336838', component.options)
    } else {
      api.reload('0e336838', component.options)
    }
    module.hot.accept("./StackAlert.vue?vue&type=template&id=0e336838&scoped=true", function () {
      api.rerender('0e336838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StackAlert.vue"
export default component.exports